import { render, staticRenderFns } from "./Expert2AssetEdit.vue?vue&type=template&id=40a123c1&scoped=true&"
import script from "./Expert2AssetEdit.vue?vue&type=script&lang=js&"
export * from "./Expert2AssetEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a123c1",
  null
  
)

export default component.exports